export const TYPES = ['primary', 'secondary', 'tertiary', 'quaternary', 'quinary']
